import { bestBuyImages } from '@/assets/images';
var normalHearingIcon = bestBuyImages.normalHearingIcon, mildHearingIcon = bestBuyImages.mildHearingIcon, severeHearingIcon = bestBuyImages.severeHearingIcon;
export var hearingLevelsExplained = [
    {
        title: 'Ok hearing',
        description: 'You can hear conversations with good clarity when there is background noise.',
        color: 'text-green',
        icon: normalHearingIcon,
    },
    {
        title: 'Hearing difficulties',
        description: 'You may have difficulty clearly following conversations when there is background noise.',
        color: 'text-orange',
        icon: mildHearingIcon,
    },
    {
        title: 'Significant hearing difficulties',
        description: 'You have significant difficulty following conversations when there is background noise.',
        color: 'text-red',
        icon: severeHearingIcon,
    },
];
